export const CONSENT_STATISTICS = 'statistics'
export const CONSENT_NECESSARY = 'necessary'
